import { gql, useFragment } from "@apollo/client";

// Constants
import { bgColorFields } from "@/constants/gql-fields";

// Styling
import style from "./footer--bottom-bar.module.scss";

// Import Components
import BackgroundColor from "@/components/bg-color/bg-color";
import Container from "../container/container";
import Copyright from "../footer--copyright/footer--copyright";
import PrivacyPolicy from "../footer--privacy-policy/footer--privacy-policy";

export default function BottomBar({ entry, copyright = [], privacy = [] }) {
  // Use Fragment
  const { complete, data } = useFragment({
    fragment: BottomBar.fragments.entry,
    fragmentName: "BottomBarFragment",
    from: {
      __typename: entry.__typename,
      id: entry.id,
    },
  });
  if (!complete) {
    return;
  }

  // Variables
  const bottomBarItems = data.footerContent.bottomBar;
  const bottomBarBgColorSettings =
    bottomBarItems.bottomBarBackgroundColor.bottomBarBgColorSettings;
  const positionOptions = ["left", "center", "right"];

  return (
    <div className={`${style.bottomBar}`}>
      {bottomBarItems.backgroundColor && bottomBarBgColorSettings && (
        <BackgroundColor colorSettings={bottomBarBgColorSettings} />
      )}
      <Container>
        <div className={style.bottomBarContainer}>
          {positionOptions.map((position, index) => {
            if (
              bottomBarItems.copyrightSettings === position ||
              bottomBarItems.privacyPolicyLocation === position
            ) {
              return (
                <div orientation={position} key={index}>
                  {bottomBarItems.copyrightSettings === position &&
                    copyright["id"] !== undefined && (
                      <Copyright entry={copyright} />
                    )}
                  {bottomBarItems.privacyPolicyLocation === position &&
                    privacy["id"] !== undefined && (
                      <PrivacyPolicy entry={privacy} />
                    )}
                </div>
              );
            }
          })}
        </div>
      </Container>
    </div>
  );
}

BottomBar.fragments = {
  entry: gql`
    fragment BottomBarFragment on GeneralSettingsACF {
      id
      __typename
      footerContent {
        bottomBar {
          copyrightSettings
          privacyPolicyLocation
          backgroundColor
          bottomBarBackgroundColor {
            bottomBarBgColorSettings {
              ${bgColorFields}
            }
          }
        }
      }
    }
  `,
};
